import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { name } from './symbols'
import { SiteServicesManagerSymbol } from '@wix/thunderbolt-symbols'
import { TestServiceDefinition } from '@wix/thunderbolt-services'
import type { ServicesManager } from '@wix/services-manager/types'
import type { TestServiceSiteConfig } from './types'

const sideEffectFactory = (
	servicesManager: ServicesManager
): IModelUpdatesHandlersImplementor<{ onViewModeChange: (siteConfig: TestServiceSiteConfig) => void }> => {
	return {
		featureName: name,
		handlers: {
			onViewModeChange: ({ viewMode }) => {
				if (servicesManager.hasService(TestServiceDefinition)) {
					const testService = servicesManager.getService(TestServiceDefinition)
					testService.setViewMode(viewMode)
				}
			},
		},
	}
}
export const SideEffect = withDependencies([SiteServicesManagerSymbol], sideEffectFactory)
